"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authenticationRequired = void 0;
const RouteInterceptor_1 = require("../RouteInterceptor");
const urlToLogin = (location) => {
    const nextPath = encodeURIComponent(`${location.pathname}${location.search}`);
    return new URL(`${location.origin}/spa/authentication/login?next=${nextPath}`).toString();
};
/**
 * If session is missing, return a redirect action that points to the login url
 * @category Interceptor
 */
const authenticationRequired = () => ({ context, location }) => {
    const redirectUrl = urlToLogin(location);
    if (!context.session) {
        return { kind: RouteInterceptor_1.RouteAction.REDIRECT_EXTERNAL, to: redirectUrl };
    }
    return null;
};
exports.authenticationRequired = authenticationRequired;
